const actions = {
    TEAM_DETAILS_START: 'TEAM_DETAILS_START',
    TEAM_DETAILS_SUCCESS: 'TEAM_DETAILS_SUCCESS',
    TEAM_DETAILS_FAILURE: 'TEAM_DETAILS_FAILURE',

    BUSINESS_DETAILS_START: 'BUSINESS_DETAILS_START',
    BUSINESS_DETAILS_SUCCESS: 'BUSINESS_DETAILS_SUCCESS',
    BUSINESS_DETAILS_FAILURE: 'BUSINESS_DETAILS_FAILURE',
    UPDATE_BUSINESS_PROFILE_DETAILS_START: 'UPDATE_BUSINESS_PROFILE_DETAILS_START',
    UPDATE_BUSINESS_PROFILE_DETAILS_SUCCESS: 'UPDATE_BUSINESS_PROFILE_DETAILS_SUCCESS',
    UPDATE_BUSINESS_PROFILE_DETAILS_FAILURE: 'UPDATE_BUSINESS_PROFILE_DETAILS_FAILURE',

    ADDRESS_DETAILS_START: 'ADDRESS_DETAILS_START',
    ADDRESS_DETAILS_SUCCESS: 'ADDRESS_DETAILS_SUCCESS',
    ADDRESS_DETAILS_FAILURE: 'ADDRESS_DETAILS_FAILURE',

    CLEAR_HOME_DETAILS_START: 'CLEAR_HOME_DETAILS_START',
    CLEAR_HOME_DETAILS_SUCCESS: 'CLEAR_HOME_DETAILS_SUCCESS',

    BUSINESS_LIST_START: 'BUSINESS_LIST_START',
    BUSINESS_LIST_SUCCESS: 'BUSINESS_LIST_SUCCESS',
    BUSINESS_LIST_FAILURE: 'BUSINESS_LIST_FAILURE',

    SUBSCRIPTION_DETAILS_START: 'SUBSCRIPTION_DETAILS_START',
    SUBSCRIPTION_DETAILS_SUCCESS: 'SUBSCRIPTION_DETAILS_SUCCESS',
    SUBSCRIPTION_DETAILS_FAILURE: 'SUBSCRIPTION_DETAILS_FAILURE',

    PARAMETER_DETAILS_START: 'PARAMETER_DETAILS_START',
    PARAMETER_DETAILS_SUCCESS: 'PARAMETER_DETAILS_SUCCESS',
    PARAMETER_DETAILS_FAILURE: 'PARAMETER_DETAILS_FAILURE',


    SUBSCRIPTION_ORDER_START: 'SUBSCRIPTION_ORDER_START',
    SUBSCRIPTION_ORDER_SUCCESS: 'SUBSCRIPTION_ORDER_SUCCESS',
    SUBSCRIPTION_ORDER_FAILURE: 'SUBSCRIPTION_ORDER_FAILURE',

    PAYMENT_CHECK_START: 'PAYMENT_CHECK_START',
    PAYMENT_CHECK_SUCCESS: 'PAYMENT_CHECK_SUCCESS',
    PAYMENT_CHECK_FAILURE: 'PAYMENT_CHECK_FAILURE',

    CLEAR_PAYMENT_CHECK_START: 'CLEAR_PAYMENT_CHECK_START',
    CLEAR_PAYMENT_CHECK_SUCCESS: 'CLEAR_PAYMENT_CHECK_SUCCESS'
};

export default actions;